// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"c989f725","194":"0e29e957","313":"c47b5698","794":"b740f720"}[chunkId] + ".chunk.js";
};